"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupTerrain = void 0;
exports.setupTerrain = function (width, height, displace, roughness) {
    var points = [];
    var power = Math.pow(2, Math.ceil(Math.log(width) / (Math.log(2))));
    points[0] = height / 2;
    points[power] = height / 2;
    displace *= roughness;
    for (var i = 1; i < power; i *= 2) {
        for (var j = (power / i) / 2; j < power; j += power / i) {
            points[j] = ((points[j - (power / i) / 2] + points[j + (power / i) / 2]) / 2);
            points[j] += (Math.random() * displace * 2) - displace;
        }
        displace *= roughness;
    }
    return points;
};
